import type {CancellablePromise} from './types';

/**
 * Delays the execution of a promise by a specified number of milliseconds.
 */
export const delay = (ms: number, value?: any): CancellablePromise<any> => {
  let timeoutId: number;

  const promise = new Promise(resolve => {
    timeoutId = +setTimeout(() => resolve(value), ms);
  });

  // @ts-expect-error: Adding cancel method to promise
  promise.cancel = () => clearTimeout(timeoutId);

  return promise as CancellablePromise<any>;
};
